module.exports = __webpack_public_path__ + "static/media/privacy.6d10e3ef.svg";